// extracted by mini-css-extract-plugin
export default {"music":"index_music__NlRUf","off":"index_off__ufkJI"};